import PropTypes from 'prop-types';

export default function InformationIsConfidentialFooter({ className }) {
    return (
        <footer id="floating-footer-container" css={className}>
            Confidential. Internal use only.
        </footer>
    );
}
InformationIsConfidentialFooter.propTypes = {
    className: PropTypes.string,
};
